import { Text } from '@huspy/briks-web';
import { Skeleton } from '@mantine/core';
import { ClientDetailsDTO } from '@modules/clients/entities/client/api/dto/clientDetails.dto';
import { OpportunityDataDTO } from '@modules/opportunities/entities/opportunity/api/dto/getOpportunityById.dto';
import { useTranslation } from 'react-i18next';
import ProgressionStepper from '@components/v2/ProgressionStepper';
import useGetCaseCreationAsideLinks from './hooks/useGetCaseCreationAsideLinks';
import type { CaseCreationEngine } from '../../hooks/useCaseCreationStateMachineEngine';

const CaseSubmissionAsideContent = ({
  isClientDataLoading,
  clientData,
  isOpportunityDataLoading,
  opportunityData,
  stateMachine,
}: {
  isClientDataLoading: boolean;
  clientData: ClientDetailsDTO | undefined;
  opportunityData: OpportunityDataDTO | undefined;
  isOpportunityDataLoading: boolean;
  stateMachine: CaseCreationEngine.StateMachine;
}) => {
  const { t } = useTranslation();
  const { asideLinks } = useGetCaseCreationAsideLinks({
    stateMachine,
    opportunity: opportunityData?.opportunity,
  });

  return (
    <ProgressionStepper
      routeId={ opportunityData?.opportunity.opportunity_external_id! }
      links={ asideLinks }
      footer={ (
        <Text size='md' color='text-tertiary'>
          {t('opportunity.caseSubmission.asideContent.disclaimer')}
        </Text>
      ) }
      header={ (
        <>
          <Text size='4xl' weight='medium'>
            {t('opportunity.caseSubmission.asideContent.title')}
          </Text>
          {!isClientDataLoading && clientData ? (
            <Text size='lg' color='text-tertiary'>
              {t(
                'opportunity.caseSubmission.asideContent.clientName',
                { clientName: `${clientData?.first_name} ${clientData?.last_name}` }
              )}
            </Text>
          ) : (
            <Skeleton h={ 18 } />
          )}
        </>
      ) }
      isLoading={ isClientDataLoading || isOpportunityDataLoading }
    />
  );
};

export default CaseSubmissionAsideContent;
